import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { DialogStatus } from 'common/components/dialogs/DialogStatus';
import { FormHelp } from 'common/components/form/FormHelp';
import { FormMoneyInput } from 'common/components/form/FormMoneyInput';
import { Formik, FormikProps } from 'formik';
import { AppState } from 'common/models/AppState';
import { Order } from 'common/api/models/Order';
import { Money } from 'common/components/Money';
import { Product } from 'common/api/models/Product';
import { FormInput } from 'common/components/form/FormInput';

export interface Adjustment {
  amount: number;
  description: string;
  productId: string;
}
interface AdjustmentDialogProps {
  isOpen: boolean;
  onSave: (saved: Adjustment) => void;
  onCancel: () => void;
  order?: Order;
  appState: AppState;
  error?: string;
  isLoading?: boolean;
}
class AdjustmentValues {
  amount = '';
  description = '';
  productId = '';
}

export class AdjustmentDialog extends React.Component<AdjustmentDialogProps> {
  validationSchema = Yup.object().shape({
    amount: Yup.number().required('Required'),
    description: Yup.string().required('Required'),
  });

  initialValues() {
    return {
      amount: '',
      checkNumber: '',
      description: '',
      productId: this.props.order ? this.props.order.items![0].productId : '',
    };
  }

  handleSubmit = (values: AdjustmentValues) => {
    let submit: Adjustment = {
      amount: Number(values.amount),
      description: values.description,
      productId: values.productId,
    };
    this.props.onSave(submit);
  };

  render() {
    const { order } = this.props;
    const products: Product[] = order
      ? order.items!.map(item => {
          return this.props.appState.entities.product[item.productId];
        })
      : [];
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<AdjustmentValues>) => (
            <form data-testid="adjustmentDialogForm" onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>Issue Adjustment</ModalHeader>
              <ModalBody>
                <FormMoneyInput
                  id="amount"
                  name="amount"
                  label={
                    <React.Fragment>
                      Reduce Amount Due By{' '}
                      <FormHelp text="Enter the amount by which you intend to reduce the current balance due. A positive number will REDUCE the outstanding balance due, a negative number will INCREASE the outstanding balance due." />
                    </React.Fragment>
                  }
                  value={form.values.amount}
                />
                <FormInput
                  label={
                    <React.Fragment>
                      Product
                      <FormHelp text="This is the product on the order that will be credited with the adjustment." />
                    </React.Fragment>
                  }
                  tag="select"
                  name="productId"
                  id="productId"
                >
                  {products.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.name} {p.sku}
                    </option>
                  ))}
                </FormInput>
                <FormInput label="Description" name="description" id="description" />
                {order &&
                  form.values.amount && (
                    <div className="row">
                      <div className="col">
                        <p data-testid="adjustmentDialogInfo">
                          You are <b>{Number(form.values.amount) > 0 ? 'reducing' : 'increasing'}</b> the amount due on
                          this order invoice to <Money value={order.billAmount! - Number(form.values.amount)} />.
                        </p>
                      </div>
                    </div>
                  )}
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit" disabled={this.props.isLoading}>
                    Create Adjustment
                  </Button>
                </div>
              </ModalFooter>
              <DialogStatus error={this.props.error} isLoading={this.props.isLoading} />
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orders/AdjustmentDialog.tsx